let breadcrumbs = [];

/**
* Create a flat array of nested breadcrumb items.
*/
const flattenNestedBreadcrumbs = (breadcrumb) => {
  breadcrumbs.push({
    title: breadcrumb.title,
    url: breadcrumb.url,
  });

  if (breadcrumb.items && breadcrumb.items.length) {
    flattenNestedBreadcrumbs(breadcrumb.items[0]);
  }
};

/**
 * Format a breadcrumb array to easier loop through them in view.
 */
export default (breadcrumb) => {
  breadcrumbs = [];
  flattenNestedBreadcrumbs(breadcrumb);

  return breadcrumbs;
};
